import { render } from "./AllInfoServices.vue?vue&type=template&id=847977b2&scoped=true"
import script from "./AllInfoServices.vue?vue&type=script&lang=js"
export * from "./AllInfoServices.vue?vue&type=script&lang=js"

import "./AllInfoServices.vue?vue&type=style&index=0&id=847977b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847977b2"]])

export default __exports__